import { Form, Label, MenuItem } from 'semantic-ui-react';
import styled from 'styled-components';

export const DrawerFooter = styled(Form.Field)`
  margin-top: 3rem !important;
  float: right;
`;

export const StyledMenuItem = styled(MenuItem)`
 .error {
  color: red;
 }
`
export const StyledGroupQuestion = styled(Form.Field)`
margin-left: 20px;
margin-right: 100px;
width: 300px;
max-width: 300px;
white-space: break-spaces;
`

export const StyledErrorLabel = styled(Label)`
  white-space: normal;
  background: #fff !important;
  border: 1px solid #e0b4b4 !important;
  color: #9f3a38 !important;
`;
